import { render, staticRenderFns } from "./servicetOfMan.vue?vue&type=template&id=3f208a3b&scoped=true&"
import script from "./servicetOfMan.vue?vue&type=script&lang=js&"
export * from "./servicetOfMan.vue?vue&type=script&lang=js&"
import style0 from "./servicetOfMan.vue?vue&type=style&index=0&id=3f208a3b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f208a3b",
  null
  
)

export default component.exports